TPS.SSA = {
    init: function () {
        this.Form.Masks.init();
        this.Form.init();
        this.PageLoader.init();
    }
};

TPS.SSA.PageLoader = {
    counter: 0,
    loader: null,
    loaderOverlay: null,

    init: function () {
        this.loader = $('.tps-osd-loader');
        this.loaderOverlay = $('.tps-osd-loader-overlay');
    },

    show: function () {
        this.counter = this.counter + 1;

        if (this.counter === 1) {
            this.loader.stop().fadeIn(300);
            this.loaderOverlay.stop().fadeIn(300);
        }
    },

    hide: function () {
        this.counter = this.counter - 1;

        if (this.counter === 0) {
            this.loader.stop().fadeOut(300);
            this.loaderOverlay.stop().fadeOut(300);
        }
    }
};

TPS.SSA.Form = {
    // Global selectors
    formWrapperSelector: '.SSA-form',
    fieldsSelector: 'input[type="text"], input[type="email"], input[type="hidden"], select, textarea',

    //Field selctor
    vinSelector: '[name="vinNumber"]',
    requestDeliveryDateSelector: '[name="requestDeliveryDate"]',
    retailerCodeSelector: '[name="retailerCode"]',
    retailerNameSelector: '[name="retailerName"]',
    salesPersonFirstNameSelector: '[name="salesPersonFirstName"]',
    salesPersonLastNameSelector: '[name="salesPersonLastName"]',
    salesPersonVPIDSelector: '[name="salesPersonVPID"]',
    selectFileSelector: '#selectFile',
    selectFileNameSelector: '#selectFileName',
    selectFileBinarySelector: '#selectFileBinary',
    selectFileIdSelector: '#selectFileId',

    claimTypeSelector: '[name="claimType"]',
    claimFleetCustomerSelector: '[name="claimFleetCustomer"]',
    claimDriverFirstNameSelector: '[name="claimDriverFirstName"]',
    claimDriverLastNameSelector: '[name="claimDriverLastName"]',
    claimDriverEmailSelector: '[name="claimDriverEmail"]',
    claimDriverPhoneSelector: '[name="claimDriverPhone"]',
    claimEmployeeFirstNameSelector: '[name="claimEmployeeFirstName"]',
    claimEmployeeLastNameSelector: '[name="claimEmployeeLastName"]',
    claimLiveryCompanyNameSelector: '[name="claimLiveryCompanyName"]',
    deliveredFirstName: '[name="deliveredFirstName"]',
    deliveredLastName: '[name="deliveredLastName"]',

    claimFleetManagementCompanySelector: '[name="claimFleetManagementCompany"]',
    claimFleetManagementCompanyOtherSelector: '[name="claimFleetManagementCompanyOther"]',

    // Date fields and helpers
    datepickerDeliveryDateSelector: '#requestDeliveryDate',

    init: function () {
        TPS.SSA.Form.datepicker();

        TPS.SSA.Form.Events.init();
        TPS.SSA.Form.Validate.init();
        TPS.SSA.Form.WS.init();
    },

    datepicker: function () {
        var self = this;
        var dateToday = new Date();
        $(this.datepickerDeliveryDateSelector).datepicker({
            dateFormat: 'mm/dd/yy',
            maxDate: new Date(new Date().setFullYear(dateToday.getFullYear())),
            changeMonth: true,
            changeYear: true,
        });
    },

    getFormData: function () {
        var self = TPS.SSA.Form;
        var data = $(self.formWrapperSelector).find(self.fieldsSelector).serializeArray();
        var dataStructured = {};

        $(data).each(function (index, obj) {
            var date;
            if (typeof dataStructured[obj.name] == 'undefined') {
                if (obj.name == 'requestDeliveryDate') {
                    date = $('#' + obj.name).datepicker('getDate');
                    dataStructured[obj.name] = $.datepicker.formatDate('yy-mm-dd', date);
                } else {
                    dataStructured[obj.name] = obj.value;
                }
            }
        });

        var parsedData = self.getParsedData(dataStructured);
        return parsedData;
    },
    getParsedData: function (data) {

        // set the driver email/phone depending on the claim type
        let driverEmail = data.claimDriverEmail;
        let driverPhone = data.claimDriverPhone;
        
        if (data.claimType === 'Care by Volvo (VELP)') {
            driverEmail = data.claimDriverEmail_velp;
            driverPhone = data.claimDriverPhone_velp;
        }

        //Claim Form
        var claimModel = {
            // ClaimID: 0, // Back-end will find this ID based on the claim
            RetailerID: data.retailerId,
            ClaimRetailerCode: data.retailerCode,
            RetailerName: data.retailerName,
            SalesPersonFirstName: data.salesPersonFirstName,
            SalesPersonLastName: data.salesPersonLastName,
            SalesPersonVPID: data.salesPersonVPID,
            ClaimType: data.claimType,
            ClaimFleetCustomer: data.claimFleetCustomer,
            ClaimDriverFirstName: data.claimDriverFirstName,
            ClaimDriverLastName: data.claimDriverLastName,
            ClaimDriverEmail: driverEmail,
            ClaimDriverPhone: driverPhone,
            ClaimEmployeeFirstName: data.claimEmployeeFirstName,
            ClaimEmployeeLastName: data.claimEmployeeLastName,
            DeliveredFirstName: data.deliveredFirstName,
            DeliveredLastName: data.deliveredLastName,
            VINNumber: data.vinNumber,
            DeliveryDate: data.requestDeliveryDate,
            ClaimFleetManagementCompany: data.claimFleetManagementCompany,
            ClaimFleetManagementCompanyOther: data.claimFleetManagementCompanyOther
        };

        //W9 Form
        var w9Model = {
            SelectFileName: data.selectFileName,
            SelectFileBinary: data.selectFileBinary,
        };

        //console.log($('#selectFile'));
        if ($(TPS.SSA.Form.selectFileSelector).length) {
            return w9Model;
        } else {
            return claimModel;
        }
    }
};

TPS.SSA.Form.WS = {
    init: function () {
        this.loadWebServices();
    },

    loadWebServices: function () {
        TPS.Util.loadWebserviceJS('CMSApp.SSA.API.Claim');
    },
}

TPS.SSA.Form.Events = {
    submitButtonSelector: '#tps-ssa-save',
    submitW9ButtonSelector: '#tps-w9-save',

    init: function () {
        this.onVinChange();
        this.onShowHideFormFields();
        this.onSubmitW9Click();
        this.onSubmitClaimClick();
        this.onRequiredFieldsFocus();
        this.onSelectFileClick();
    },

    //Submit W9 Form
    onSubmitW9Click: function () {
        $(document).on('click', this.submitW9ButtonSelector, function (e) {
            e.preventDefault();
            var isValid = TPS.SSA.Form.Validate.isValid();
            if (!isValid) {
                TPS.SSA.Form.Validate.showFormErrorMessage();
                return false;
            }
            TPS.SSA.PageLoader.show();

            CMSApp.SSA.API.Claim.SubmitW9Form(TPS.SSA.Form.getFormData().SelectFileName, TPS.SSA.Form.getFormData().SelectFileBinary, function (data) {
                if (data.Success && data.Success == true) {
                    alert('Form saved!');
                    window.location.href = './Submit-W9-Success';
                } else {
                    alert('Error saving form. Please refresh the page and try again.');
                }

                TPS.SSA.PageLoader.hide();
            }, function () {
                alert('Error saving form. Please refresh the page and try again.');
                TPS.SSA.PageLoader.hide();
            });
        });
    },

    //Submit Claim Form
    onSubmitClaimClick: function () {
        $(document).on('click', this.submitButtonSelector, function (e) {
            e.preventDefault();
            var isValid = TPS.SSA.Form.Validate.isValid();

            if (!isValid) {
                TPS.SSA.Form.Validate.showFormErrorMessage();
                return false;
            }

            TPS.SSA.PageLoader.show();
            CMSApp.SSA.API.Claim.SubmitClaim(TPS.SSA.Form.getFormData(), function (data) {

                if (data.Success && data.Success == true && data.InfoMessages && data.InfoMessages.length > 0) {
                    alert('Form saved!');
                    window.location.href = './Submit-Form-Success';

                } else if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                    alert(data.ErrorMessages[0]);
                } else {
                    alert('Error saving form. Please refresh the page and try again.');
                }

                TPS.SSA.PageLoader.hide();
            }, function () {
                alert('Error saving form. Please refresh the page and try again.');
                TPS.SSA.PageLoader.hide();
            });
        });
    },

    onShowHideFormFields: function () {
        
        let showHideFormFields = $('[data-display-field-name]');
        showHideFormFields.each(function (k, v) {
            let elem = $(v);
            let fieldName = elem.data('displayFieldName');
            let activeValues = elem.data('displayFieldValues').toString().split(';');
            $(document).on('change', '[name="' + fieldName + '"]', function (e) {
                if ((activeValues.indexOf('*') > -1 && this.value !== '') || activeValues.indexOf(this.value) > -1) {
                    elem.show();
                } else {
                    elem.hide();
                    TPS.SSA.Form.Events.resetHiddenInput(elem);
                }
            });
        });
        /*
        $(document).on('change', TPS.SSA.Form.offerSelector, function (e) {
            console.log(this.value);
        });
        */
    },

    // receives a jquery element object
    resetHiddenInput: function (elem) {

        const childInputs = elem.find(':input');
        childInputs.each(function () {
            if ($(this).is(':radio') || jQuery(this).is(':checkbox')) {
                $(this).prop('checked', false);
            } else if ($(this).attr('type') != 'hidden' && $(this).attr('type') != 'submit') {
                $(this).val('');
            }
            $(this).trigger('change');
        });


    },

    onVinChange: function () {
        var _this = this;
        $(document).on('blur', TPS.SSA.Form.vinSelector, function (e) {

            var el, elVal, elLen, elParent, submitBtn, elErrorClasses, elSuccessClasses, elValidatingClasses, elEmptyErrorClasses;

            el = $(this);
            elVal = el.val().trim();
            elLen = elVal.length;
            elParent = el.closest('.form-control-wrapper');
            submitBtn = $(_this.submitButtonSelector);
            elErrorClasses = 'error error-vinnumber';

            if (!elParent.hasClass('validating') && !el.prop('disabled') && elLen > 0) {

                elSuccessClasses = 'success success-vinnumber';
                elValidatingClasses = 'validating validating-vinnumber';
                elEmptyErrorClasses = 'error error-required';

                // reset field state (valid/invalid)
                elParent.addClass(elValidatingClasses).removeClass(elErrorClasses).removeClass(elSuccessClasses).removeClass(elEmptyErrorClasses);

                el.prop('disabled', true);
                submitBtn.prop('disabled', true);

                CMSApp.SSA.API.Claim.VerifyVIN(elVal,
                    function (d) {
                        var parentClass = elErrorClasses;
                        var message = d.ErrorMessages;
                        var isValid = false;
                        if (d.Success) {
                            parentClass = elSuccessClasses;
                            message = '';
                            isValid = true;
                        }
                        el.data('isValid', isValid).prop('disabled', false);
                        submitBtn.prop('disabled', false);
                        elParent.children('.editing-form-control-nested-control').attr('data-validation-message', message);
                        elParent.removeClass(elValidatingClasses).addClass(parentClass);
                    },
                    function (d) {
                        elParent.removeClass(elValidatingClasses);
                        el.data('isValid', false).prop('disabled', false);
                        submitBtn.prop('disabled', false);
                    }
                );
            }
            // if field is empty on blur,
            // show required message "please enter a value"
            else if (elLen === 0) {
                elParent.removeClass(elValidatingClasses).removeClass(elErrorClasses).removeClass(elSuccessClasses).addClass(elEmptyErrorClasses);
                el.data('isValid', false);
            }

        });
    },

    onSelectFileClick: function () {
        $(document).on('change', TPS.SSA.Form.selectFileSelector, function (e) {
            TPS.SSA.PageLoader.show();

            var input = e.target;
            var reader = new FileReader();

            reader.onload = function (event) {
                var data = event ? event.target.result : reader.content;

                $(TPS.SSA.Form.selectFileBinarySelector).val(data);

                TPS.SSA.PageLoader.hide();
            };

            reader.onerror = function (event) {
                console.error('File could not be read! Error code ' + event.target.error.code);
            };

            reader.readAsDataURL(input.files[0]);
            $(TPS.SSA.Form.selectFileNameSelector).val(input.files[0].name);
        });
    },

    onRequiredFieldsFocus: function () {
        $(document).on('focus', TPS.SSA.Form.fieldsSelector, function (e) {
            $(this).filter(TPS.SSA.Form.Validate.filterRequired).each(function () {
                TPS.SSA.Form.Validate.removeError(this);
            });
        });
    },
};

TPS.SSA.Form.Masks = {
    emailSelector: '#claimDriverEmail, #claimDriverEmail_velp',
    phoneSelector: '#claimDriverPhone, #claimDriverPhone_velp',
    init: function () {
        // this.setZipCodeMask(); // Only called on country change event AND on order load
        this.setPhoneMask();
        this.setEmailMask();
    },
    setPhoneMask: function () {
        var self = TPS.SSA.Form.Masks;
        $(self.phoneSelector).unmask().mask('(000) 000-0000');
    },
    setEmailMask: function () {
        var self = TPS.SSA.Form.Masks;

        $(self.emailSelector).unmask().mask('A', {
            translation: {
                'A': { pattern: /[\w@\-.+]/, recursive: true }
            }
        });
    },

};

TPS.SSA.Form.Validate = {
    formErrorMessageSelector: '#formError',

    init: function () {
        this.addFormErrorMessage();
    },

    addFormErrorMessage: function () {
        $(TPS.SSA.Form.formWrapperSelector).find('.tps-osd-form-form-section:last-child .columns').append('<p class="ErrorLabel" id="formError" style="display: none">The entered values cannot be saved. Please see the fields above for details.</p>');
    },

    hideFormErrorMessage: function (el) {
        $(TPS.SSA.Form.Validate.formErrorMessageSelector).hide();
    },

    showFormErrorMessage: function (el) {
        $(TPS.SSA.Form.Validate.formErrorMessageSelector).show();
    },

    removeError: function (el) {
        TPS.SSA.Form.Validate.hideFormErrorMessage();
        $(el).closest('.form-control-wrapper').removeClass('error').removeClass('error-email').removeClass('error-offernumber').removeClass('error-required');
    },

    filterEmail: function (index) {
        var hasNoPrevError = !$(this).closest('.form-control-wrapper').hasClass('error');
        var isEmail = $(this).attr('type') == 'email';
        return hasNoPrevError && isEmail;
    },

    filterRequired: function (index) {
        if ($(this).attr('name')) {
            var isRequired = $(this).closest('.form-control-wrapper:visible').hasClass('required');
        }

        return isRequired;
    },

    isValid: function () {
        var valid = true;

        $(TPS.SSA.Form.fieldsSelector).each(function () {
            TPS.SSA.Form.Validate.removeError(this);
        });

        $(TPS.SSA.Form.fieldsSelector).filter(TPS.SSA.Form.Validate.filterRequired).each(function () {
            var val = $.trim($(this).val());

            if (val == '') {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error').addClass('error-required');
            }
        });

        $(TPS.SSA.Form.fieldsSelector).filter(TPS.SSA.Form.Validate.filterEmail).each(function () {
            var val = $.trim($(this).val());

            if (val != '' && !TPS.Util.validateEmail(val)) {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error').addClass('error-email');
            }
        });


        // check if PIN/VIN numbers are valid
        $(TPS.SSA.Form.fieldsSelector).filter(TPS.SSA.Form.vinSelector).each(function () {
            var val = $.trim($(this).val());
            if (val !== '' && $(this).data('isValid') !== true) {
                valid = false;
                $(this).closest('.form-control-wrapper').addClass('error error-vinnumber')
            }
        });

        return valid;
    }
};

// W9 Form page

TPS.SSA.W9Form = {
    init: function () {
        TPS.SSA.PageLoader.init();
        TPS.SSA.Form.WS.init();
        TPS.SSA.Form.Events.init();
        TPS.SSA.Form.Validate.init();
    },
};
